import { render, staticRenderFns } from "./closeAccount.vue?vue&type=template&id=128c713e&"
import script from "./closeAccount.vue?vue&type=script&lang=js&"
export * from "./closeAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128c713e')) {
      api.createRecord('128c713e', component.options)
    } else {
      api.reload('128c713e', component.options)
    }
    module.hot.accept("./closeAccount.vue?vue&type=template&id=128c713e&", function () {
      api.rerender('128c713e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/mtCloseAccount/closeAccount.vue"
export default component.exports